export default {"src":"/_next/static/media/crown.3eb4d16b.svg","height":11,"width":17,"blurWidth":0,"blurHeight":0};